import React from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'

import BkFlowRoomCardUpSellsCurrentRoom from './BkFlowRoomCardUpSellsCurrentRoom'
import BkFlowRoomCardUpSellsCards from './BkFlowRoomCardUpSellsCards'

import getCurrencySymbol from '../../../utilities/currency/getCurrencySymbol'
import placeholderImage from '../../../assets/images/placeholder-image.png'

import _ from 'lodash'
import yn from 'yn'

import '../../../styles/css/components/upsells/bk-flow-room-card-upsells.css'

const BkFlowRoomCardUpSells = props => {
  const {
    activeStep,
    availabilityData,
    configData,
    currentRoomData,
    currentRoomRate,
    currentRoomType,
    currentUpSells,
    enhancementData,
    multiRoomData,
    roomGroup,
    toggleActiveRoom,
    toggledState,
    toggleEvent,
    totalNights,
    urlData,
  } = props

  const hotelLabels = configData.hotel.labels[0]

  let renderedUpSells = [...currentUpSells]
  let activeHotelCode = null
  let matchedProperty = null
  let selectedRoomRateData = null
  let selectedRoomTypeName = null
  let selectedRoomTypeImage = placeholderImage
  let selectedRoomRateName = null
  let selectedRoomRatePrice = null
  let selectedRoomRateCurrencyCode = null
  let selectedRoomRateCurrencySymbol = null
  let displayedPriceFrequency = 'per stay'

  if (
    !_.isEmpty(urlData) &&
    urlData.hotelCode
  ) {
    activeHotelCode = urlData.hotelCode
  }

  if (!_.isEmpty(configData)) {
    const configProperties = configData.hotel.options.properties

    matchedProperty = configProperties.find(function (property) {
      return property.hotelCode === String(activeHotelCode)
    })
  }

  if (matchedProperty) {
    if (matchedProperty.displayPricesTimeline) {
      displayedPriceFrequency = matchedProperty.displayPricesTimeline
    }
  }

  const handleUpSellActiveRoom = (roomType, roomRate) => {
    toggleActiveRoom(
      availabilityData,
      roomType,
      roomRate,
      roomGroup,
      activeStep,
      multiRoomData,
      configData,
      urlData,
      enhancementData
    )
  }

  // Selected room rate price
  if (
    currentRoomData.viewExtensions &&
    currentRoomData.viewExtensions.roomRates
  ) {
    const currentRoomRateData = currentRoomData.viewExtensions.roomRates.filter(function(roomRate) {
      return String(roomRate.ratePlanCode) === String(currentRoomRate)
    })

    if (
      currentRoomRateData &&
      currentRoomRateData[0]
    ) {
      selectedRoomRateData = currentRoomRateData[0]
    }
  }

  const selectedRatePlanData = availabilityData[roomGroup][0].ratePlans.find(function(ratePlan) {
    return ratePlan.ratePlanCode === currentRoomRate
  })

  // Selected room name
  if (
    currentRoomData &&
    currentRoomData.roomDescription &&
    currentRoomData.roomDescription.name
  ) {
    selectedRoomTypeName = currentRoomData.roomDescription.name
  }

  // Selected room image
  if (
    currentRoomData.viewExtensions &&
    currentRoomData.viewExtensions.roomTypeImages &&
    currentRoomData.viewExtensions.roomTypeImages[0] &&
    currentRoomData.viewExtensions.roomTypeImages[0].path
  ) {
    selectedRoomTypeImage = currentRoomData.viewExtensions.roomTypeImages[0].path
  }

  // Selected rate plan  name
  if (
    selectedRatePlanData &&
    selectedRatePlanData.ratePlanName
  ) {
    selectedRoomRateName = selectedRatePlanData.ratePlanName
  }

  if (
    selectedRoomRateData &&
    selectedRoomRateData.rates &&
    selectedRoomRateData.rates[0] &&
    selectedRoomRateData.rates[0].total
  ) {
    if (
      selectedRoomRateData.rates[0].total.amountBeforeTax &&
      totalNights
    ) {
      if (displayedPriceFrequency === 'per stay') {
        selectedRoomRatePrice = selectedRoomRateData.rates[0].total.amountBeforeTax
      } else {
        selectedRoomRatePrice = selectedRoomRateData.rates[0].total.amountBeforeTax / totalNights
      }
    }

    // Selected room rate price
    if (selectedRoomRateData.rates[0].total.currencyCode) {
      selectedRoomRateCurrencyCode = selectedRoomRateData.rates[0].total.currencyCode
      selectedRoomRateCurrencySymbol = getCurrencySymbol(selectedRoomRateCurrencyCode)
    }

    // Remove available upSells if their rate is lower than the currently selected roomRate price
    if (yn(process.env.REACT_APP_COMPONENT_UP_SELLS_EXCLUDE_NEGATIVE_RATES)) {
      for (const upSellKey in currentUpSells) {
        const currentUpSell = currentUpSells[upSellKey]

        // Retrieve each upSell roomType data
        const upSellRoomTypeData = availabilityData[roomGroup][0].roomTypes.filter(function(roomType) {
          return roomType.roomTypeCode === currentUpSell.roomTypeCode
        })

        // Retrieve specific roomRate data from upSell roomType data
        if (
          upSellRoomTypeData &&
          _.get(upSellRoomTypeData, '[0].viewExtensions.roomRates') &&
          !_.isEmpty(upSellRoomTypeData[0].viewExtensions.roomRates)
        ) {
          const upSellRoomRate = upSellRoomTypeData[0].viewExtensions.roomRates.filter(function(roomRate) {
            return roomRate.ratePlanCode === currentUpSell.ratePlanCode && roomRate.roomTypeCode === currentUpSell.roomTypeCode
          })

          if (
            upSellRoomRate &&
            _.get(upSellRoomRate, '[0].rates[0].total.amountBeforeTax')
          ) {
            let upSellRoomRatePrice = null

            if (displayedPriceFrequency === 'per stay') {
              upSellRoomRatePrice = upSellRoomRate[0].rates[0].total.amountBeforeTax
            } else {
              upSellRoomRatePrice = upSellRoomRate[0].rates[0].total.amountBeforeTax / totalNights
            }

            // Modify currentUpSells array to remove negative upSells before cards are rendered
            if (
              upSellRoomRatePrice &&
              Number(upSellRoomRatePrice < Number(selectedRoomRatePrice))
            ) {
              _.remove(renderedUpSells, function(upSell) {
                return upSell.roomTypeCode === upSellRoomRate[0].roomTypeCode && upSell.ratePlanCode === upSellRoomRate[0].ratePlanCode
              })
            }
          }
        }
      }

      // Advance to next step with currently selected roomType and rateCode if modified upSells array is now empty
      if (currentUpSells.length < 1) {
        handleUpSellActiveRoom(currentRoomType, currentRoomRate)
      }
    }
  }

  return (
    <Modal
      className={{
        base: 'u-modal u-modal--md',
        afterOpen: 'u-modal--visible',
        beforeClose: 'u-modal--close',
        ariaHideApp: false
      }}
      overlayClassName={{
        base: 'u-fade',
        afterOpen: 'u-fade--visible',
        beforeClose: 'u-fade--visible'
      }}
      isOpen={ toggledState }
      onRequestClose={ toggleEvent }
      contentLabel="Up Sells Modal"
      shouldCloseOnOverlayClick={ true }
      ariaHideApp={ false }
    >
      <div className="bk-flow-room__card-upsells">
        <div className="u-modal__header">
          <h4>{ hotelLabels && hotelLabels.upgradeYourRoom ? hotelLabels.upgradeYourRoom : 'Upgrade Your Room' }</h4>
          <div
            className="u-modal__close u-font-small u-font-bold"
            onClick={ toggleEvent }
          >
            { hotelLabels.close }
            <i className="material-icons">close</i>
          </div>
        </div>

        <div className="u-modal__body">
          <BkFlowRoomCardUpSellsCurrentRoom
            configData={configData}
            displayedPriceFrequency={displayedPriceFrequency}
            selectedRoomTypeName={selectedRoomTypeName}
            selectedRoomTypeImage={selectedRoomTypeImage}
            selectedRoomRateName={selectedRoomRateName}
            selectedRoomRatePrice={selectedRoomRatePrice}
            selectedRoomRateCurrencyCode={selectedRoomRateCurrencyCode}
            selectedRoomRateCurrencySymbol={selectedRoomRateCurrencySymbol}
            handleSkipEvent={() => handleUpSellActiveRoom(currentRoomType, currentRoomRate)}
          />

          {
            <BkFlowRoomCardUpSellsCards
                roomGroup={roomGroup}
                totalNights={totalNights}
                currentUpSells={renderedUpSells}
                selectedRoomRatePrice={selectedRoomRatePrice}
                handleUpgradeEvent={handleUpSellActiveRoom}
              />
          }

          <div className="bk-flow-room__card-upsells-continue">
            <button
              className="btn btn-transparent"
              onClick={() => handleUpSellActiveRoom(currentRoomType, currentRoomRate)}
            >
              { hotelLabels && hotelLabels.continueWith ? hotelLabels.continueWith : 'Continue with'} { selectedRoomTypeName }
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

function mapStateToProps(state) {
  return {
    activeStep: state.activeStepData.activeStep,
    availabilityData: state.availabilityData.availability,
    configData: state.configData.configuration,
    enhancementData: state.enhancementData,
    multiRoomData: state.multiRoomData,
    urlData: state.availabilityData.urlData,
  }
}

export default connect(mapStateToProps, null)(BkFlowRoomCardUpSells)



// WEBPACK FOOTER //
// ./src/components/room/upsells/BkFlowRoomCardUpSells.js